export default __webpack_public_path__ + "static/tab-property02-69e084e29ac02e1ad036c3940f32eb4a.jpg";